export default "__VITE_ASSET__87d1c8a0__"